import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { personalInformation } from 'shared/store/actions';
import selectors from 'shared/store/selectors';
import { FORM_KEYS, SOURCE_OF_WEALTH_IDS, SOW_ESTIMATED_WEALTH_IDS, SOW_NET_INCOME_IDS } from 'shared/constant';
// import arrOptions from 'shared/constant/arrOptions';
import {
  PaddedContainer,
  Options, Label,
  FormElementContainer, Input,
  // SelectBox,
} from 'components';
import validation from 'shared/validations';

class SourceOfWealth extends Component {
  onElementChange = (e) => {
    const fieldName = e.target.name;
    const fieldValue = e.target.value;
    this.props.onUpdateSourceOfWealth(fieldName, fieldValue);
    // console.log(e);
  }

  onHandleSelect = (name, value) => {
    if (name && value) this.props.onUpdateSourceOfWealth(name, value);
  }

  onHandleMultiSelect = ({ target: { name, id } }) => {
    const oldData = this.props[name] || '';
    let arrOldData = oldData.split(',');
    if (arrOldData.includes(id)) arrOldData = arrOldData.filter(item => item !== id);
    else arrOldData.push(id);
    arrOldData = arrOldData.filter(item => !!item);
    this.props.onUpdateSourceOfWealth(name, arrOldData.toString());
  }

  render() {
    const {
      intl, estimatedWealth, sourceOfWealthFunds, netIncome, otherSourceOfWealth,
      estimatedWealthApproxValue, netIncomeApproxValue,
      formOptions: {
        sourcesOfFunds,
        // estimatedWealthOptions,
        // netIncomeOptions
      },
      isSubmitClicked,
      totalYearOfExp, detailOfRel, yrOfInheritance, approxValOfInheritance, typeOfAssetMarket, approxValInvSav, detailOfBiz, typeOfActivity, approxRevenue,
    } = this.props;
    const { SOURCE_OF_WEALTH } = FORM_KEYS;
    // const {
    //   sourcesOfFunds, estimatedWealthOptions, netIncomeOptions,
    //   // netAssetOptions,
    // } = arrOptions;

    const elementValidation = {
      [SOURCE_OF_WEALTH.WEALTH_FUNDS]: {
        isValid: validation.sourceOfWealthScheme(intl, SOURCE_OF_WEALTH.WEALTH_FUNDS, estimatedWealth, netIncome).isValidSync({ sourceOfWealthFunds }),
        errorMessage: validation.getErrorMessages({ sourceOfWealthFunds }, validation.sourceOfWealthScheme(intl, SOURCE_OF_WEALTH.WEALTH_FUNDS, estimatedWealth, netIncome)),
      },
      [SOURCE_OF_WEALTH.TOTAL_YRS_EXP]: {
        isValid: validation.otherSourceOfWealthSchema(intl, SOURCE_OF_WEALTH.TOTAL_YRS_EXP, sourceOfWealthFunds).isValidSync({ totalYearOfExp }),
        errorMessage: validation.getErrorMessages({ totalYearOfExp }, validation.otherSourceOfWealthSchema(intl, SOURCE_OF_WEALTH.TOTAL_YRS_EXP, sourceOfWealthFunds)),
      },
      [SOURCE_OF_WEALTH.DETAIL_OF_REL]: {
        isValid: validation.otherSourceOfWealthSchema(intl, SOURCE_OF_WEALTH.DETAIL_OF_REL, sourceOfWealthFunds).isValidSync({ detailsOfRelationShip: detailOfRel }),
        errorMessage: validation.getErrorMessages({ detailsOfRelationShip: detailOfRel }, validation.otherSourceOfWealthSchema(intl, SOURCE_OF_WEALTH.DETAIL_OF_REL, sourceOfWealthFunds)),
      },
      [SOURCE_OF_WEALTH.YR_OR_INHERITANCE]: {
        isValid: validation.otherSourceOfWealthSchema(intl, SOURCE_OF_WEALTH.YR_OR_INHERITANCE, sourceOfWealthFunds).isValidSync({ yearOfInheritance: yrOfInheritance }),
        errorMessage: validation.getErrorMessages({ yearOfInheritance: yrOfInheritance }, validation.otherSourceOfWealthSchema(intl, SOURCE_OF_WEALTH.YR_OR_INHERITANCE, sourceOfWealthFunds)),
      },
      [SOURCE_OF_WEALTH.APPROX_VAL_OF_INHERITANCE]: {
        isValid: validation.otherSourceOfWealthSchema(intl, SOURCE_OF_WEALTH.APPROX_VAL_OF_INHERITANCE, sourceOfWealthFunds).isValidSync({ approxValueOfInherited: approxValOfInheritance }),
        errorMessage: validation.getErrorMessages({ approxValueOfInherited: approxValOfInheritance }, validation.otherSourceOfWealthSchema(intl, SOURCE_OF_WEALTH.APPROX_VAL_OF_INHERITANCE, sourceOfWealthFunds)),
      },
      [SOURCE_OF_WEALTH.TYPE_ASSET_MARKET]: {
        isValid: validation.otherSourceOfWealthSchema(intl, SOURCE_OF_WEALTH.TYPE_ASSET_MARKET, sourceOfWealthFunds).isValidSync({ typesOfAssetsAndMarkets: typeOfAssetMarket }),
        errorMessage: validation.getErrorMessages({ typesOfAssetsAndMarkets: typeOfAssetMarket }, validation.otherSourceOfWealthSchema(intl, SOURCE_OF_WEALTH.TYPE_ASSET_MARKET, sourceOfWealthFunds)),
      },
      [SOURCE_OF_WEALTH.APPROX_VAL_INV_SAV]: {
        isValid: validation.otherSourceOfWealthSchema(intl, SOURCE_OF_WEALTH.APPROX_VAL_INV_SAV, sourceOfWealthFunds).isValidSync({ approxValueOfInvestmentsAndSavings: approxValInvSav }),
        errorMessage: validation.getErrorMessages({ approxValueOfInvestmentsAndSavings: approxValInvSav }, validation.otherSourceOfWealthSchema(intl, SOURCE_OF_WEALTH.APPROX_VAL_INV_SAV, sourceOfWealthFunds)),
      },
      [SOURCE_OF_WEALTH.DETAIL_OF_BIZ]: {
        isValid: validation.otherSourceOfWealthSchema(intl, SOURCE_OF_WEALTH.DETAIL_OF_BIZ, sourceOfWealthFunds).isValidSync({ typeOfActivity }),
        errorMessage: validation.getErrorMessages({ typeOfActivity }, validation.otherSourceOfWealthSchema(intl, SOURCE_OF_WEALTH.DETAIL_OF_BIZ, sourceOfWealthFunds)),
      },
      [SOURCE_OF_WEALTH.APPROX_VAL_REV]: {
        isValid: validation.otherSourceOfWealthSchema(intl, SOURCE_OF_WEALTH.APPROX_VAL_REV, sourceOfWealthFunds).isValidSync({ approxValueOfRevenues: approxRevenue }),
        errorMessage: validation.getErrorMessages({ approxValueOfRevenues: approxRevenue }, validation.otherSourceOfWealthSchema(intl, SOURCE_OF_WEALTH.APPROX_VAL_REV, sourceOfWealthFunds)),
      },
      [SOURCE_OF_WEALTH.TYPE_OF_ACT]: {
        isValid: validation.otherSourceOfWealthSchema(intl, SOURCE_OF_WEALTH.TYPE_OF_ACT, sourceOfWealthFunds).isValidSync({ detailsOfBusinessName: detailOfBiz }),
        errorMessage: validation.getErrorMessages({ detailsOfBusinessName: detailOfBiz }, validation.otherSourceOfWealthSchema(intl, SOURCE_OF_WEALTH.TYPE_OF_ACT, sourceOfWealthFunds)),
      },
      [SOURCE_OF_WEALTH.OTHER_SOURCE_OF_WEALTH]: {
        isValid: validation.otherSourceOfWealthSchema(intl, SOURCE_OF_WEALTH.OTHER_SOURCE_OF_WEALTH, sourceOfWealthFunds).isValidSync({ otherSourceOfWealth }),
        errorMessage: validation.getErrorMessages({ otherSourceOfWealth }, validation.otherSourceOfWealthSchema(intl, SOURCE_OF_WEALTH.OTHER_SOURCE_OF_WEALTH, sourceOfWealthFunds)),
      },
      [SOURCE_OF_WEALTH.ESTIMATED_WEALTH]: {
        isValid: validation.sourceOfWealthScheme(intl, SOURCE_OF_WEALTH.ESTIMATED_WEALTH, estimatedWealth, netIncome).isValidSync({ estimatedWealth }),
        errorMessage: validation.getErrorMessages({ estimatedWealth }, validation.sourceOfWealthScheme(intl, SOURCE_OF_WEALTH.ESTIMATED_WEALTH, estimatedWealth, netIncome)),
      },
      [SOURCE_OF_WEALTH.NET_INCOME]: {
        isValid: validation.sourceOfWealthScheme(intl, SOURCE_OF_WEALTH.NET_INCOME, estimatedWealth, netIncome).isValidSync({ netIncome }), // BE68539007547034
        errorMessage: validation.getErrorMessages({ netIncome }, validation.sourceOfWealthScheme(intl, SOURCE_OF_WEALTH.NET_INCOME, estimatedWealth, netIncome)),
      },
      [SOURCE_OF_WEALTH.ESTIMATED_WEALTH_APPROX_VAL]: {
        isValid: validation.sourceOfWealthScheme(intl, SOURCE_OF_WEALTH.ESTIMATED_WEALTH_APPROX_VAL, estimatedWealth, netIncome).isValidSync({ estimatedWealthApproxValue }),
        errorMessage: validation.getErrorMessages({ estimatedWealthApproxValue }, validation.sourceOfWealthScheme(intl, SOURCE_OF_WEALTH.ESTIMATED_WEALTH_APPROX_VAL, estimatedWealth, netIncome)),
      },
      [SOURCE_OF_WEALTH.NET_INCOME_APPROX_VAL]: {
        isValid: validation.sourceOfWealthScheme(intl, SOURCE_OF_WEALTH.NET_INCOME_APPROX_VAL, estimatedWealth, netIncome).isValidSync({ netIncomeApproxValue }),
        errorMessage: validation.getErrorMessages({ netIncomeApproxValue }, validation.sourceOfWealthScheme(intl, SOURCE_OF_WEALTH.NET_INCOME_APPROX_VAL, estimatedWealth, netIncome)),
      },
    };

    return (
      <PaddedContainer isRtl={this.props.appLanguage.locale === 'AR'}>
        <FormElementContainer>

          <FormElementContainer>
            <Label label={intl.formatMessage({ id: 'sourceOfWealth' })} />
            <Options
              type="checkbox"
              hasContainer
              name={SOURCE_OF_WEALTH.WEALTH_FUNDS}
              optionList={sourcesOfFunds}
              onCheckMarkChange={this.onHandleMultiSelect}
              defaultValue={sourceOfWealthFunds}
              isValid={elementValidation[SOURCE_OF_WEALTH.WEALTH_FUNDS].isValid}
              errorMessage={elementValidation[SOURCE_OF_WEALTH.WEALTH_FUNDS].errorMessage}
              isSubmitClicked={isSubmitClicked}
            />
            {/* <SelectBox
              label={intl.formatMessage({ id: 'sourceOfWealth' })}
              placeholder={`${intl.formatMessage({ id: 'select' })} ${intl.formatMessage({ id: 'sourceOfWealth' })}`}
              hasContainer
              name={SOURCE_OF_WEALTH.WEALTH_FUNDS}
              dataList={sourcesOfFunds}
              onSelect={this.onHandleSelect}
              defaultValue={sourceOfWealthFunds}
              isValid={elementValidation[SOURCE_OF_WEALTH.WEALTH_FUNDS].isValid}
              errorMessage={elementValidation[SOURCE_OF_WEALTH.WEALTH_FUNDS].errorMessage}
              isSubmitClicked={isSubmitClicked}
            /> */}
          </FormElementContainer>

          {sourceOfWealthFunds?.includes(SOURCE_OF_WEALTH_IDS.SAL_PRO_INCOME_PENSION) && (
            <FormElementContainer>
              <Input
                label={intl.formatMessage({ id: 'sourceOfWealth.totalExp' })}
                placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'sourceOfWealth.totalExp' }).toLowerCase()}`}
                name={SOURCE_OF_WEALTH.TOTAL_YRS_EXP}
                onInputChange={this.onElementChange}
                value={totalYearOfExp}
                isValid={elementValidation[SOURCE_OF_WEALTH.TOTAL_YRS_EXP].isValid}
                errorMessage={elementValidation[SOURCE_OF_WEALTH.TOTAL_YRS_EXP].errorMessage}
                isSubmitClicked={isSubmitClicked}
              />
            </FormElementContainer>
          )}

          {sourceOfWealthFunds?.includes(SOURCE_OF_WEALTH_IDS.INHERITANCE) && (
            <>
              <p><strong>{intl.formatMessage({ id: 'sourceOfWealth.inheritance' })}</strong></p>
              <FormElementContainer>
                <Input
                  label={intl.formatMessage({ id: 'sourceOfWealth.detailRel' })}
                  placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'sourceOfWealth.detailRel' }).toLowerCase()}`}
                  name={SOURCE_OF_WEALTH.DETAIL_OF_REL}
                  onInputChange={this.onElementChange}
                  value={detailOfRel}
                  isValid={elementValidation[SOURCE_OF_WEALTH.DETAIL_OF_REL].isValid}
                  errorMessage={elementValidation[SOURCE_OF_WEALTH.DETAIL_OF_REL].errorMessage}
                  isSubmitClicked={isSubmitClicked}
                />
              </FormElementContainer>
              <FormElementContainer>
                <Input
                  label={intl.formatMessage({ id: 'sourceOfWealth.yearInherit' })}
                  placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'sourceOfWealth.yearInherit' }).toLowerCase()}`}
                  name={SOURCE_OF_WEALTH.YR_OR_INHERITANCE}
                  onInputChange={this.onElementChange}
                  value={yrOfInheritance}
                  isValid={elementValidation[SOURCE_OF_WEALTH.YR_OR_INHERITANCE].isValid}
                  errorMessage={elementValidation[SOURCE_OF_WEALTH.YR_OR_INHERITANCE].errorMessage}
                  isSubmitClicked={isSubmitClicked}
                />
              </FormElementContainer>
              <FormElementContainer>
                <Input
                  label={intl.formatMessage({ id: 'sourceOfWealth.approxValInherit' })}
                  placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'sourceOfWealth.approxValInherit' }).toLowerCase()}`}
                  isCurrency
                  name={SOURCE_OF_WEALTH.APPROX_VAL_OF_INHERITANCE}
                  onInputChange={this.onElementChange}
                  value={approxValOfInheritance}
                  isValid={elementValidation[SOURCE_OF_WEALTH.APPROX_VAL_OF_INHERITANCE].isValid}
                  errorMessage={elementValidation[SOURCE_OF_WEALTH.APPROX_VAL_OF_INHERITANCE].errorMessage}
                  isSubmitClicked={isSubmitClicked}
                />
              </FormElementContainer>
            </>
          )}

          {sourceOfWealthFunds?.includes(SOURCE_OF_WEALTH_IDS.INV_SAVINGS) && (
            <>
              <p><strong>{intl.formatMessage({ id: 'sourceOfWealth.investmentsSavings' })}</strong></p>
              <FormElementContainer>
                <Input
                  label={intl.formatMessage({ id: 'sourceOfWealth.typeAssetMarket' })}
                  placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'sourceOfWealth.typeAssetMarket' }).toLowerCase()}`}
                  name={SOURCE_OF_WEALTH.TYPE_ASSET_MARKET}
                  onInputChange={this.onElementChange}
                  value={typeOfAssetMarket}
                  isValid={elementValidation[SOURCE_OF_WEALTH.TYPE_ASSET_MARKET].isValid}
                  errorMessage={elementValidation[SOURCE_OF_WEALTH.TYPE_ASSET_MARKET].errorMessage}
                  isSubmitClicked={isSubmitClicked}
                />
              </FormElementContainer>
              <FormElementContainer>
                <Input
                  label={intl.formatMessage({ id: 'sourceOfWealth.approxValInv' })}
                  placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'sourceOfWealth.approxValInv' }).toLowerCase()}`}
                  isCurrency
                  name={SOURCE_OF_WEALTH.APPROX_VAL_INV_SAV}
                  onInputChange={this.onElementChange}
                  value={approxValInvSav}
                  isValid={elementValidation[SOURCE_OF_WEALTH.APPROX_VAL_INV_SAV].isValid}
                  errorMessage={elementValidation[SOURCE_OF_WEALTH.APPROX_VAL_INV_SAV].errorMessage}
                  isSubmitClicked={isSubmitClicked}
                />
              </FormElementContainer>
            </>
          )}

          {sourceOfWealthFunds?.includes(SOURCE_OF_WEALTH_IDS.TRADE_BIZ) && (
            <>
              <p><strong>{intl.formatMessage({ id: 'sourceOfWealth.trade' })}</strong></p>
              <FormElementContainer>
                <Input
                  label={intl.formatMessage({ id: 'sourceOfWealth.bizName' })}
                  placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'sourceOfWealth.bizName' }).toLowerCase()}`}
                  name={SOURCE_OF_WEALTH.DETAIL_OF_BIZ}
                  onInputChange={this.onElementChange}
                  value={detailOfBiz}
                  isValid={elementValidation[SOURCE_OF_WEALTH.DETAIL_OF_BIZ].isValid}
                  errorMessage={elementValidation[SOURCE_OF_WEALTH.DETAIL_OF_BIZ].errorMessage}
                  isSubmitClicked={isSubmitClicked}
                />
              </FormElementContainer>
              <FormElementContainer>
                <Input
                  label={intl.formatMessage({ id: 'sourceOfWealth.typeAct' })}
                  placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'sourceOfWealth.typeAct' }).toLowerCase()}`}
                  name={SOURCE_OF_WEALTH.TYPE_OF_ACT}
                  onInputChange={this.onElementChange}
                  value={typeOfActivity}
                  isValid={elementValidation[SOURCE_OF_WEALTH.TYPE_OF_ACT].isValid}
                  errorMessage={elementValidation[SOURCE_OF_WEALTH.TYPE_OF_ACT].errorMessage}
                  isSubmitClicked={isSubmitClicked}
                />
              </FormElementContainer>
              <FormElementContainer>
                <Input
                  label={intl.formatMessage({ id: 'sourceOfWealth.approxRev' })}
                  placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'sourceOfWealth.approxRev' }).toLowerCase()}`}
                  isCurrency
                  name={SOURCE_OF_WEALTH.APPROX_VAL_REV}
                  onInputChange={this.onElementChange}
                  value={approxRevenue}
                  isValid={elementValidation[SOURCE_OF_WEALTH.APPROX_VAL_REV].isValid}
                  errorMessage={elementValidation[SOURCE_OF_WEALTH.APPROX_VAL_REV].errorMessage}
                  isSubmitClicked={isSubmitClicked}
                />
              </FormElementContainer>
            </>
          )}

          {sourceOfWealthFunds?.includes(SOURCE_OF_WEALTH_IDS.OTHERS) && (
            <>
              <p><strong>{intl.formatMessage({ id: 'sourceOfWealth.others' })}</strong></p>
              <FormElementContainer>
                <Input
                  label={intl.formatMessage({ id: 'sourceOfWealth.otherSourceOfWealth' })}
                  placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'sourceOfWealth.otherSourceOfWealth' }).toLowerCase()}`}
                  name={SOURCE_OF_WEALTH.OTHER_SOURCE_OF_WEALTH}
                  onInputChange={this.onElementChange}
                  value={otherSourceOfWealth}
                  isValid={elementValidation[SOURCE_OF_WEALTH.OTHER_SOURCE_OF_WEALTH].isValid}
                  errorMessage={elementValidation[SOURCE_OF_WEALTH.OTHER_SOURCE_OF_WEALTH].errorMessage}
                  isSubmitClicked={isSubmitClicked}
                />
              </FormElementContainer>
            </>
          )}
        </FormElementContainer>

        {sourceOfWealthFunds && <hr style={{ borderColor: '#DDDDDD' }} />}

        <FormElementContainer>
          <Input
              label={intl.formatMessage({ id: 'sourceOfWealth.estimatedWealth' })}
              placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'sourceOfWealth.estimatedWealth' })}`}
              name={SOURCE_OF_WEALTH.ESTIMATED_WEALTH}
              onInputChange={this.onElementChange}
              value={estimatedWealth}
              isValid={elementValidation[SOURCE_OF_WEALTH.ESTIMATED_WEALTH].isValid}
              errorMessage={elementValidation[SOURCE_OF_WEALTH.ESTIMATED_WEALTH].errorMessage}
              isSubmitClicked={isSubmitClicked}
              isCurrency
          />
          {/*<SelectBox*/}
          {/*  label={intl.formatMessage({ id: 'sourceOfWealth.estimatedWealth' })}*/}
          {/*  placeholder={`${intl.formatMessage({ id: 'select' })} ${intl.formatMessage({ id: 'sourceOfWealth.estimatedWealth' })}`}*/}
          {/*  hasContainer*/}
          {/*  name={SOURCE_OF_WEALTH.ESTIMATED_WEALTH}*/}
          {/*  dataList={estimatedWealthOptions}*/}
          {/*  onSelect={this.onHandleSelect}*/}
          {/*  defaultValue={estimatedWealth}*/}
          {/*  isValid={elementValidation[SOURCE_OF_WEALTH.ESTIMATED_WEALTH].isValid}*/}
          {/*  errorMessage={elementValidation[SOURCE_OF_WEALTH.ESTIMATED_WEALTH].errorMessage}*/}
          {/*  isSubmitClicked={isSubmitClicked}*/}
          {/*/>*/}
        </FormElementContainer>
        {(estimatedWealth === SOW_ESTIMATED_WEALTH_IDS.BELOW_500K || estimatedWealth === SOW_ESTIMATED_WEALTH_IDS.ABOVE_10M) && (
          <>
            <FormElementContainer>
              <Input
                label={intl.formatMessage({ id: 'sourceOfWealth.estimatedWealthApproxVal' })}
                placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'sourceOfWealth.estimatedWealthApproxVal' }).toLowerCase()}`}
                name={SOURCE_OF_WEALTH.ESTIMATED_WEALTH_APPROX_VAL}
                onInputChange={this.onElementChange}
                value={estimatedWealthApproxValue}
                isValid={elementValidation[SOURCE_OF_WEALTH.ESTIMATED_WEALTH_APPROX_VAL].isValid}
                errorMessage={elementValidation[SOURCE_OF_WEALTH.ESTIMATED_WEALTH_APPROX_VAL].errorMessage}
                isSubmitClicked={isSubmitClicked}
                isCurrency
              />
            </FormElementContainer>
            <hr style={{ borderColor: '#DDDDDD' }} />
          </>
        )}

        <FormElementContainer>
          <Input
              label={intl.formatMessage({ id: 'sourceOfWealth.annIncome' })}
              placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'sourceOfWealth.annIncome' })}`}
              name={SOURCE_OF_WEALTH.NET_INCOME}
              onInputChange={this.onElementChange}
              value={netIncome}
              isValid={elementValidation[SOURCE_OF_WEALTH.NET_INCOME].isValid}
              errorMessage={elementValidation[SOURCE_OF_WEALTH.NET_INCOME].errorMessage}
              isSubmitClicked={isSubmitClicked}
              isCurrency
          />
          {/*<SelectBox*/}
          {/*  label={intl.formatMessage({ id: 'sourceOfWealth.annIncome' })}*/}
          {/*  placeholder={`${intl.formatMessage({ id: 'select' })} ${intl.formatMessage({ id: 'sourceOfWealth.annIncome' })}`}*/}
          {/*  hasContainer*/}
          {/*  isTopPos*/}
          {/*  name={SOURCE_OF_WEALTH.NET_INCOME}*/}
          {/*  dataList={netIncomeOptions}*/}
          {/*  onSelect={this.onHandleSelect}*/}
          {/*  defaultValue={netIncome}*/}
          {/*  isValid={elementValidation[SOURCE_OF_WEALTH.NET_INCOME].isValid}*/}
          {/*  errorMessage={elementValidation[SOURCE_OF_WEALTH.NET_INCOME].errorMessage}*/}
          {/*  isSubmitClicked={isSubmitClicked}*/}
          {/*/>*/}
        </FormElementContainer>
        {(netIncome === SOW_NET_INCOME_IDS.BELOW_50K || netIncome === SOW_NET_INCOME_IDS.ABOVE_1M) && (
          <FormElementContainer>
            <Input
              label={intl.formatMessage({ id: 'sourceOfWealth.netIncomeApproxVal' })}
              placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'sourceOfWealth.netIncomeApproxVal' }).toLowerCase()}`}
              name={SOURCE_OF_WEALTH.NET_INCOME_APPROX_VAL}
              onInputChange={this.onElementChange}
              value={netIncomeApproxValue}
              isValid={elementValidation[SOURCE_OF_WEALTH.NET_INCOME_APPROX_VAL].isValid}
              errorMessage={elementValidation[SOURCE_OF_WEALTH.NET_INCOME_APPROX_VAL].errorMessage}
              isSubmitClicked={isSubmitClicked}
              isCurrency
            />
          </FormElementContainer>
        )}

      </PaddedContainer>
    );
  }
}

const mapStateToProps = state => ({
  appLanguage: selectors.getLanguage(state),
  formOptions: selectors.getFormOptions(state),
  estimatedWealth: selectors.getEstimatedWealth(state),
  estimatedWealthApproxValue: selectors.getWealthApproxVal(state),
  sourceOfWealthFunds: selectors.getSourceOfWealth(state),
  netAssets: selectors.getNetAssets(state),
  netIncome: selectors.getNetIncome(state),
  netIncomeApproxValue: selectors.getNetIncomeApproxVal(state),
  otherSourceOfWealth: selectors.getOtherSourceOfWealth(state),
  isSubmitClicked: selectors.getIsFormSubmitted(state),

  totalYearOfExp: selectors.getTotalYrsExp(state),
  detailOfRel: selectors.getDetailOfRel(state),
  yrOfInheritance: selectors.getYrOfInheritance(state),
  approxValOfInheritance: selectors.getApproxValOfInheritance(state),
  typeOfAssetMarket: selectors.getTypeOfAssetMarket(state),
  approxValInvSav: selectors.getApproxValInvSav(state),
  detailOfBiz: selectors.getDetailOfBiz(state),
  typeOfActivity: selectors.getTypeOfActvity(state),
  approxRevenue: selectors.getApproxRevenue(state),
});

const mapDispatchToProps = dispatch => ({
  onUpdateSourceOfWealth: (name, value) => dispatch(personalInformation.updateSourceOfWealth(name, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(SourceOfWealth));
